export default {
  init(authBase) {
    const requestCall = authBase;
    return {
      fetchAccountData(requestPayload) {
        return requestCall.accountData(requestPayload);
      },
      postContributionsData(requestPayload) {
        return requestCall.submitRecommendForm(requestPayload);
      }
    };
  }
};
